import { useContext, useEffect } from 'react'
import { Colorcontext } from '../../Component/Colorcontext/ColorContext';
import FAQAccordion from './FAQAccordion';
import SeoGeneral from '../BusinessPage/SeoGeneral';

const FaqListPage = () => {
    const colordata = useContext(Colorcontext);
    useEffect(() => {
        colordata.setcolor(true);
        return () => {
            colordata.setcolor(false);
        };
    }, []);

    const seoMetaData = {
        title: "NeooSearch Frequently Asked Questions - FAQ",
        description: "Find answers to common questions about NeooSearch, your local search engine and business directory. Get help, tips, and guidance quickly.",
        ogImage: "https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png",
        ogImageAlt: "NeooSearch – FAQ",
        url: process.env.REACT_APP_APPLICATION_URL + "/faq",
        keywords: "NeooSearch, FAQ, frequently asked questions, business listing pricing, plans",
        type: "website",
        site_name: "NeooSearch",
        canonical: process.env.REACT_APP_APPLICATION_URL + "/faq"
    };

    return (
        <>
            <SeoGeneral data={seoMetaData} />
            <section className='searchloginmain'>
                <div className='cust_container'>
                    <div className='bg-wht'>
                        <div className=''>
                            <FAQAccordion />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FaqListPage
